import { Component, Input } from '@angular/core';
import {
	NavController,
    NavParams } from 'ionic-angular';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { Observable } from 'rxjs';
import { Rodeo } from '../../../../model/rodeo';
import { RunDisplayHelper } from '../../../../lib/run-display-helper';

@Component({
	selector: 'page-carryovers-report',
	templateUrl: 'report-carryovers.html'
	
})
export class CarryOversReport {
    @Input('rodeo') rodeo: Rodeo;

    documentTitle: any;
    printing: boolean;

    searchChangeObservable;

    searchName: string;

    selectedRodeoEvent: RodeoEvent;

    dataLoaded: boolean;
    popoverActive: boolean;

    searchResults: any[];
    rodeoEventsById: any[];

    runDisplayHelper: RunDisplayHelper = RunDisplayHelper.instance();

    constructor(private nav: NavController, navParams: NavParams) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');

        this.searchName = navParams.get('searchName');

        this.printing = navParams.get('printing');

        if (this.printing) {
            setTimeout(() => {
                this.load();
            }, 0);
        }
    }

    load() {
        this.updateRodeoEvent();

        this.documentTitle = this.rodeo.name + " - " + 'Carry Overs';
        this.dataLoaded = true;
    }

    updateRodeoEvent() {
        if (!this.selectedRodeoEvent && this.rodeo && this.rodeo.rodeoEvents.length > 0) {
            this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];
        }

        this.searchResults = [];
        this.rodeoEventsById = [];

        this.rodeo.rodeoEvents.filter(x => x.id != this.selectedRodeoEvent.id).forEach((rodeoEvent) => {
            this.rodeoEventsById[rodeoEvent.id] = rodeoEvent;

            if (this.searchName) {
                var firstName = this.searchName.split(' ')[0];
                var lastName = this.searchName.split(' ')[1];
                if (firstName && !lastName) {
                    this.searchResults.push(...rodeoEvent.registrations.filter(x =>
                        x.carryOverIds.some(x => x == this.selectedRodeoEvent.id)
                        && (
                        (
                            x.contestantOne.firstName.toLowerCase().includes(firstName.toLocaleLowerCase())
                            || (x.contestantTwo && x.contestantTwo.firstName && x.contestantTwo.firstName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                        )
                        || (
                            x.contestantOne.lastName.toLowerCase().includes(firstName.toLocaleLowerCase())
                            || (x.contestantTwo && x.contestantTwo.lastName && x.contestantTwo.lastName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                        ))));
                } else {
                    this.searchResults.push(...rodeoEvent.registrations.filter(x =>
                        x.carryOverIds.some(x => x == this.selectedRodeoEvent.id)
                        && (
                        (
                            x.contestantOne.firstName.toLowerCase().includes(firstName.toLocaleLowerCase())
                            || (x.contestantTwo && x.contestantTwo.firstName && x.contestantTwo.firstName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                        )
                        && (
                            x.contestantOne.lastName.toLowerCase().includes(lastName.toLocaleLowerCase())
                            || (x.contestantTwo && x.contestantTwo.lastName && x.contestantTwo.lastName.toLowerCase().includes(lastName.toLocaleLowerCase()))
                        ))));
                }
            } else {
                this.searchResults.push(...rodeoEvent.registrations.filter(x =>
                    x.carryOverIds.some(x => x == this.selectedRodeoEvent.id)));
            }

            this.searchResults.forEach((registration) => {
                let contestantOneId = registration.teammateHeader ? registration.contestantTwoId : registration.contestantOneId;
                let contestantTwoId = registration.teammateHeader ? registration.contestantOneId : registration.contestantTwoId;
                let horseOneId = registration.teammateHeader ? registration.horseTwoId : registration.horseOneId;
                let horseTwoId = registration.teammateHeader ? registration.horseOneId : registration.horseTwoId;

                let runs = this.rodeo.rodeoEvents.filter(x => x.id == registration.rodeoEventId).flatMap(x => x.schedules).flatMap(x => x.runs).filter(x => 
                    x.contestantOneId == contestantOneId
                    && (!registration.horseOneId || horseOneId == x.horseOneId)
                    && (!contestantTwoId || contestantTwoId == x.contestantTwoId)
                    && (!registration.horseTwoId || horseTwoId == x.horseTwoId));
        
                if (registration.rodeoEventId != this.selectedRodeoEvent.id) {
                    let rodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id == registration.rodeoEventId)[0];
                    let carryOver = rodeoEvent.carryOvers.filter(x => x.carryOverId == this.selectedRodeoEvent.id)[0];
                    runs = carryOver.sourceRound != 0 ? runs.filter(x => x.round == carryOver.sourceRound) : runs.filter(x => x.round == 1);
                }

                let maxRuns = 1;
                
                if (rodeoEvent.ropingFormat == 'Draw')
                    maxRuns = rodeoEvent.drawAmount;
                else if (rodeoEvent.ropingFormat == 'PickAndDraw') {
                    maxRuns += rodeoEvent.drawAmount;
                }
        
                let run = runs.filter(x => !x.used)[0];
                if (run && run != null) {
                    registration.run = new RodeoEventRun();
                    Object.assign(registration.run, run);
                }
            });
        });
    }

    onNameSearchChange(searchValue) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(700)
                .distinctUntilChanged()
                .subscribe((text) => {
                    this.updateRodeoEvent();
                });
        }

        this.searchChangeObservable.next(searchValue);
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    getRodeoEventName(rodeoEventId) {
        let rodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id == rodeoEventId)[0];
        return rodeoEvent ? rodeoEvent.displayName : '';
    }

    hasCarryOver(registration, carryOver) {
        return registration.carryOverIds.some(x => x == carryOver.carryOverId);
    }

    isRoughStock(rodeoEventId) {
        if (this.rodeoEventsById[rodeoEventId].eventType === 'BullRiding' || this.rodeoEventsById[rodeoEventId].eventType === 'SaddleBroncRiding' || this.rodeoEventsById[rodeoEventId].eventType === 'RanchBroncRiding' || this.rodeoEventsById[rodeoEventId].eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop(); 
        }, 0);
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        this.nav.push(CarryOversReport, {
            rodeo: this.rodeo,
            selectedRodeoEvent: this.selectedRodeoEvent,
            searchName: this.searchName,
            printing: true
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-carryovers.ts